module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book-container"
  }, [_c('div', {
    staticClass: "book-progress"
  }, [_vm._v("\n    " + _vm._s(_vm.progress) + "%\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "book-content"
  }, [_c('div', {
    staticClass: "book-title"
  }, [_vm._t("title")], 2), _vm._v(" "), _c('div', {
    staticClass: "book-author"
  }, [_vm._t("author")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-3ae7301c"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/tools/Book/Book.vue
// module id = 344
// module chunks = 1